<template>
  <v-layout>
    <v-flex xs12>
      <v-dialog persistent v-model="loadingDialog" full-width>
        <div style="width: 100%; height: 80vh; display: flex; align-items: center; justify-content: center">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate></v-progress-circular>
        </div>
      </v-dialog>
      <v-dialog v-model="dialog" width="100vh">
        <v-card class="pa-2">
          <v-card-title class="px-3 pt-3">
            <h4 class="font-weight-bold">送信 Summary</h4>
          </v-card-title>
          <v-divider class="my-1 mx-3"></v-divider>
          <v-data-table
            :headers="headers_summary"
            :items="specificHistoryData"
            :search="search"
            class="elevation-0 ma-3"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center"><a :href=props.item.fileURL>{{ props.item.fileOriginalName }}</a></td>
              <td class="text-xs-center">{{ props.item.requestNum }}</td>
              <td class="text-xs-center">{{ props.item.successNum }}</td>
              <td class="text-xs-center">{{ props.item.failureNum }}</td>
              <td class="text-xs-center">{{ convert(props.item.requestTime) }}</td>
              <td class="text-xs-center">{{ convert(props.item.completionTime) }}</td>
              <td class="text-xs-center">{{ props.item.workingTime }}</td>
            </template>
          </v-data-table>
          <v-card-title class="px-3 pt-3">
            <h4 class="font-weight-bold">送信メッセージの内容確認</h4>
          </v-card-title>
          <v-divider class="my-1 mx-3"></v-divider>
          <div class="px-3 mb-3">
            <v-textarea
              v-model="msgPreview"
              full-width
              outline
              no-resize
              hide-details
              readonly
              height="200px"
            ></v-textarea>
          </div>
          <v-card-title class="px-3 pt-3">
            <h4 class="font-weight-bold">送信エラーの詳細</h4>
          </v-card-title>
          <v-divider class="my-1 mx-3"></v-divider>
          <v-data-table
            :headers="headers_error_summary"
            :items="specificErrorData"
            :search="search"
            class="elevation-0 ma-3"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.item.formatError }}</td>
              <td class="text-xs-center">{{ props.item.addressError }}</td>
              <td class="text-xs-center">{{ props.item.powerOffError }}</td>
              <td class="text-xs-center">{{ props.item.shadeError }}</td>
              <td class="text-xs-center">{{ props.item.providerError }}</td>
              <td class="text-xs-center">{{ props.item.spamError }}</td>
              <td class="text-xs-center">{{ props.item.etcError }}</td>
            </template>
          </v-data-table>

          <v-data-table
            :headers="headers_error_summary_list"
            :items="specificErrorDataList"
            :search="search"
            class="elevation-0 ma-3"
            hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ (errorPagination.page - 1) * errorPagination.size + (props.index + 1) }}
              </td>
              <td class="text-xs-center">{{ props.item.destNo }}</td>
              <td class="text-xs-center">{{ props.item.description }}</td>
            </template>
          </v-data-table>
          <div class="text-xs-center my-2">
            <v-pagination v-model="errorPagination.page" :length="errorPagination.totalPages"
                          :total-visible="7"
                          @input="errPaginationClick" color="#43425d"></v-pagination>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat class="border-1" @click="dialog = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <v-layout justify-space-between px-3 pt-3>
          <v-card-title>
            <v-layout column>
              <h4 class="font-weight-bold ml-3 mt-3">送信履歴
              <span class="ml-2 blue-grey--text fs-14  ml-3 mt-2">過去1週間の送信履歴が1分周期に更新されます</span>
              </h4>
            </v-layout>
          </v-card-title>
          <v-spacer></v-spacer>
          <div class="pr-1">
            <v-btn
              flat
              outline
              icon
              small
              color="#bbbbbb"
              :disabled="isUnusable()">
              <v-icon @click="pageLoad">refresh</v-icon>
            </v-btn>
          </div>
        </v-layout>
        <v-divider class="my-1 mx-3"></v-divider>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="sendHistory"
          :search="search"
          class="elevation-0 ma-3">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ (pagination.page - 1) * pagination.size + (props.index + 1) }}</td>
            <td class="text-xs-center">{{ props.item.sendType }}</td>
            <td class="text-xs-center"><a :href=props.item.sendFileName>{{ props.item.fileOriginalName }}</a></td>
            <td class="text-xs-center">{{ convert(props.item.uploadTime) }}</td>
            <td class="text-xs-center" v-if="false"></td>
            <td class="text-xs-center">{{ props.item.sendShipments }}</td>
            <td class="text-xs-center">{{ convert(props.item.sendTime) }}</td>
            <td class="text-xs-center">{{ props.item.sendSuccess }}</td>
            <td class="text-xs-center">{{ props.item.sendFailure }}</td>
            <td class="text-xs-center">{{ convert(props.item.sendCompleteTime) }}</td>
            <td class="text-xs-center">
              <div v-if=props.item.isSendRequestServed>{{props.item.sendStatus}}</div>
              <v-btn small class="registration" v-if=(!props.item.isSendRequestServed)
                     v-on:click=finalSubmitRequest(props.item)>送信する
              </v-btn>
            </td>
            <td class="text-xs-center">
              <v-btn v-if=props.item.isSendCompleted v-on:click=openDialog(props.item.originalData) small
                     color="orange darken-1" dark>詳細を見る
              </v-btn>
            </td>
            <td class="text-xs-center">{{ props.item.recital }}</td>
          </template>
        </v-data-table>
        <div class="text-xs-center my-3">
          <v-pagination v-model="pagination.page" :length="pagination.totalPages"
                        @input="paginationClick"></v-pagination>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import util from '@/util'
import helper from 'util/helpers'
import eventBus from '@/event_bus'
import {mapGetters} from 'vuex'

export default {
  name: 'send_message_history',
  computed: {
    ...mapGetters([
      'currentBrandId'
    ])
  },
  data () {
    return {
      usable: false,
      timer: null,
      loadingDialog: false,
      dialog: false,
      msgPreview: '',
      headers: [
        {text: 'NO', align: 'center', value: 'number', sortable: false},
        {text: '送信タイプ', align: 'center', value: 'sendType', sortable: false},
        {text: 'ファイル名', align: 'center', value: 'sendTime', sortable: false},
        {text: '送信要請時間', align: 'center', value: 'sendTime', sortable: false},
        {text: '送信可能件数', align: 'center', value: 'sendShipments', sortable: false},
        {text: '送信開始時間', align: 'center', value: 'sendRequestTime', sortable: false},
        {text: '成功', align: 'center', value: 'sendSuccess', sortable: false},
        {text: '失敗', align: 'center', value: 'sendFailure', sortable: false},
        {text: '送信終了時間', align: 'center', value: 'sendCompleteTime', sortable: false},
        {text: '進行状態', align: 'center', value: 'progressStatus', sortable: false},
        {text: '詳細を見る', align: 'center', value: 'viewDetails', sortable: false},
        {text: '備考', align: 'center', value: 'recital', sortable: false}
      ],
      headers_summary: [
        {text: 'ファイル名', align: 'center', value: 'formatError', sortable: false},
        {text: '要請', align: 'center', value: 'addressError', sortable: false},
        {text: '成功', align: 'center', value: 'powerOffError', sortable: false},
        {text: '失敗', align: 'center', value: 'shadeError', sortable: false},
        {text: '送信開始時間', align: 'center', value: 'providerError', sortable: false},
        {text: '送信終了時間', align: 'center', value: 'spamError', sortable: false},
        {text: '所要時間', align: 'center', value: 'etcError', sortable: false}],
      headers_error_summary: [
        {text: '形式エラー', align: 'center', value: 'formatError', sortable: false},
        {text: '欠番 | サービス停止', align: 'center', value: 'addressError', sortable: false},
        {text: '電源オフ', align: 'center', value: 'powerOffError', sortable: false},
        {text: '음영지역', align: 'center', value: 'shadeError', sortable: false},
        {text: '이통사오류', align: 'center', value: 'providerError', sortable: false},
        {text: '스팸오류', align: 'center', value: 'spamError', sortable: false},
        {text: 'その他エラー', align: 'center', value: 'etcError', sortable: false}
      ],
      headers_error_summary_list: [
        {text: 'No', align: 'center', value: 'number', sortable: false},
        {text: '電話番号', align: 'center', value: 'phoneNumber', sortable: false},
        {text: 'エラー内訳', align: 'center', value: 'errorText', sortable: false}
      ],
      search: '',
      sendHistory: [],
      specificHistoryData: [{
        fileOriginalName: '',
        requestNum: 0,
        successNum: 0,
        failureNum: 0,
        requestTime: '',
        completionTime: '',
        workingTime: ''
      }],
      specificErrorData: [{
        formatError: 0,
        addressError: 0,
        powerOffError: 0,
        shadeError: 0,
        providerError: 0,
        spamError: 0,
        etcError: 0
      }],
      specificErrorDataList: [],
      pagination: {
        page: 1,
        size: 10,
        totalPages: 0,
        totalElements: 0
      },
      errorPagination: {
        page: 1,
        size: 5,
        totalPages: 0,
        totalElements: 0
      }
    }
  },
  created () {
    this.checkAvailability()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    checkAvailability () {
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.currentBrandId,
          moduleName: 'MESSAGE',
          channelName: 'KAKAO_INSTANT_MESSAGE'
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.usable = true
          this.pageLoad()
          this.timer = setInterval(() => this.requestHistorySummary(this.pagination.page), 30000)
          eventBus.$on('message-hisotry-refresh', () => this.pageLoad())
        }
      })
    },
    isUnusable () {
      return !this.usable
    },
    pageLoad () {
      this.requestHistorySummary(1)
      this.pagination.page = 1
    },
    paginationClick (page) {
      this.requestHistorySummary(page)
    },
    errPaginationClick () {
      this.fetchFailedLog(this.selectedHistory.id, this.errorPagination.page)
    },
    requestHistorySummary (page) {
      let agentId = util.parseLoginToken().agentId
      this.axios.get('/gateway/message/kakao-instant-message/history', {
        params: {
          agentId: agentId,
          page,
          size: this.pagination.size
        }
      }).then((response) => {
        if (response.data.code !== 0) throw response.data.message
        this.pagination.totalItems = response.data.totalElements
        this.pagination.totalPages = response.data.totalPages
        this.renderHistory(response)
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMessage => this.$alertMsg(errorMessage))
    },
    renderHistory (result) {
      let resultArr = []
      let count = 1
      result.data.data.forEach(temp => {
        resultArr.push(this.makeHistoryJSON(temp, count))
        count++
      })
      this.sendHistory = resultArr
      this.closeLoadingDialog()
    },
    makeHistoryJSON (data, count) {
      let filename = '-'
      const sendreqTime = data.sendreqTime
      const endDate = data.endDate
      const uploadTime = data.uploadDate

      if (data.originalExcelName) {
        filename = data.originalExcelName
      } else {
        if (!data.fileUrl) {
          filename = '直接送信' + uploadTime
        }
      }

      const {sendStatus, isSendRequestServed, isSendCompleted} = this.convertSendStatusString(data.sendStatus)

      return {
        number: count,
        fileOriginalName: filename,
        sendFileName: data.fileUrl,
        sendType: this.convertToSendType(data.msgType),
        sendShipments: data.sendreqCount,
        sendFailure: data.failCount !== undefined ? data.failCount : '-',
        sendSuccess: data.successCount !== undefined ? data.successCount : '-',
        uploadTime: uploadTime,
        sendTime: sendreqTime,
        sendCompleteTime: endDate,
        sendStatus,
        isSendRequestServed,
        isSendCompleted,
        originalData: data,
        recital: data.validateError ? data.validateError : '-',
        msgPreview: this.sliceLine(data.msgPreview),
        msgPreviewOriginal: data.msgPreview,
        advertiseRefused: data.refusedCount
      }
    },
    convertSendStatusString (status) {
      switch (status) {
        case 'UPLOAD':
          return {sendStatus: 'アップロード', isSendRequestServed: false, isSendCompleted: false}
        case 'LOADING':
          return {sendStatus: 'データ伝達中', isSendRequestServed: true, isSendCompleted: false}
        case 'SEND':
          return {sendStatus: '転送完了', isSendRequestServed: true, isSendCompleted: true}
        case 'REFUSEDALL':
          return {sendStatus: '全受信拒否', isSendRequestServed: true, isSendCompleted: true}
        case 'ERROR':
          return {sendStatus: 'フォーマットエラー', isSendRequestServed: true, isSendCompleted: false}
        case 'COMPLETION':
          return {sendStatus: '転送完了', isSendRequestServed: true, isSendCompleted: true}
        default:
          return {sendStatus: '未定義', isSendRequestServed: true, isSendCompleted: true}
      }
    },
    convert (dateTime) {
      return dateTime !== undefined ? helper.convertCreateDateToYYYYMMDDhhmmss(dateTime) : '-'
    },
    openLoadingDialog () {
      this.loadingDialog = true
    },
    closeLoadingDialog () {
      this.loadingDialog = false
    },
    finalSubmitRequest (data) {
      this.openLoadingDialog()
      let agentId = util.parseLoginToken().agentId
      this.axios.post('/gateway/message/kakao-instant-message/send', {
        brandId: this.currentBrandId,
        agentId: agentId,
        messageHistoryId: data.originalData.id
      }).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.pageLoad()
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMessage => this.$alertMsg(errorMessage))
    },
    convertToSendType (msgType) {
      switch (msgType) {
        case 'S':
          return 'SMS'
        case 'L':
          return 'LMS'
        case 'C':
          return 'SMS/LMS'
        case 'K':
          return '通知トーク'
      }
    },
    sliceLine (data) {
      let result = ''
      if (data) {
        const resultArr = data.split('\n')
        resultArr.some((line, index) => {
          if (index === resultArr.length - 1) {
            result += line
          } else {
            result += (line + '\n')
          }
          if (index === 2) {
            return true
          }
        })
      }
      if (result.split('\n').length >= 3) {
        return result + '.....'
      } else {
        return result
      }
    },
    openDialog (data) {
      this.selectedHistory = null
      this.errorPagination.page = 1
      this.selectedHistory = data
      this.fetchFailedLog(data.id, 1)
      this.msgPreview = data.msgPreview
      let filename = '-'
      const sendreqTime = data.sendreqTime
      const completionTime = data.endDate
      const uploadTime = data.uploadDate

      if (data.fileUrl) {
        let fileNameArr = data.fileUrl.split('/')
        let fileOriginalName = fileNameArr[5].split('_')
        filename = fileOriginalName[0] + '.xlsx'
      } else {
        filename = '直接送信' + uploadTime
      }
      this.specificHistoryData = [{
        fileOriginalName: filename,
        requestNum: data.sendreqCount,
        successNum: data.successCount,
        failureNum: data.failCount,
        requestTime: sendreqTime,
        completionTime: completionTime,
        workingTime: completionTime !== '-' && sendreqTime !== '-' ? this.convertSecToHOUR((completionTime - sendreqTime)) : '-',
        fileURL: data.fileUrl
      }]

      this.axios.get(`/gateway/message/history/error?id=${data.id}`).then((result) => {
        this.specificErrorData = [{
          formatError: result.data.data.formatErrorCount,
          addressError: result.data.data.addressErrorCount,
          powerOffError: result.data.data.powerOffErrorCount,
          shadeError: result.data.data.shadeErrorCount,
          providerError: result.data.data.providerErrorCount,
          spamError: result.data.data.spamErrorCount,
          etcError: result.data.data.etcErrorCount
        }]
      })

      this.dialog = true
    },
    fetchFailedLog (historyId, page) {
      this.axios.get('/gateway/message/log/fail', {
        params: {
          historyId: historyId,
          page,
          size: this.errorPagination.size
        }
      }).then((result) => {
        if (result.data.code !== 0) throw result.data.message
        this.errorPagination.totalPages = result.data.totalPages
        this.specificErrorDataList = result.data.data
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
    },
    convertSecToHOUR (time) {
      if (!time) {
        return '-'
      } else if (time > 60) {
        return Math.round(time / 60) + '分 ' + Math.round(time % 60) + '秒 '
      } else if (time > 3600) {
        return Math.round(time / 3600) + '時間 ' + Math.round((time % 3600) / 60) + '分 ' + Math.round((time % 3600) % 60) + '秒'
      } else {
        return time + '秒'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/message/fragments/send_message_history.vue